module.exports = __webpack_public_path__ + "img/show_img2.ded3969f.png";